// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import 'jquery/dist/jquery.js'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store/index.js'
import Bus from './shared/Bus.js'
import { mapMutations, mapGetters, mapState } from 'vuex'
import { isWeiXin, GetUserInfo } from './shared/utils.js'
import {
  _prcpcoAPP,
  _versionAPP,
  _SM_540,
  _NOTIFY_RECHARGE_BOTTOM_TABBAR_SHOW,
  _NOTIFY_MAIN_TABBAR_SHOW,
  _NOTIFY_SHOPPING_BOTTOM_TABBAR_SHOW,
  _NOTIFY_GOODSDETAILS_BOTTOM_TABBAR_SHOW,
  _NOTIFY_MY_BOTTOM_TABBAR_SHOW
} from './shared/global.js'

Vue.use(BootstrapVue)

Vue.config.productionTip = false

if (_versionAPP === _prcpcoAPP) {
  axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.baseURL = 'http://49.235.143.93:80'// 高原茶油微信后台
} else {
  axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.baseURL = 'https://yuenongyueguo.com' // 云鼎微信后台
}
Vue.prototype.$axios = axios

// 设置cookie,增加到vue实例方便全局调用
// vue全局调用的理由是，有些组件所用到的接口可能需要session验证，session从cookie获取
// 当然，如果session保存到vuex的话除外
Vue.prototype.setCookie = (cName, value, expiredays) => {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    cName +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}

// 获取cookie、
function getCookie (name) {
  // eslint-disable-next-line one-var
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')

  if ((arr = document.cookie.match(reg))) {
    return arr[2]
  } else {
    return null
  }
}
Vue.prototype.getCookie = getCookie

// 删除cookie
Vue.prototype.delCookie = name => {
  var exp = new Date()
  exp.setTime(exp.getTime() + -1 * 24 * 60 * 60 * 1000)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  data () {
    return {
      // 保存用户信息
      UserInfo: {
        User_ID: 0,
        UserName: '', // 用户登录名
        ImgName: '', // 操作员头像文件名
        LoginStatu: 1, // 0 : 登录成功 1：登录失败（未登录）  2： 其他
        CommLoginStatu: 1, // 通讯登录状态 0 : 登录成功  1：连接失败  2： 服务器认证不通过 3：其他
        UserGrade_ID: 1, // 用户级别，默认没登陆的是嘉宾油友
        MoblieNo: '', // 用户手机号
        Surplus: 0, // 余额
        Points: 0,
        wxOpenID: '',
        wxUnionID: '',
        NickName: '',
        RegTime: '',
        LastLoginTime: '',
        IsAgent: 0
      }
    }
  },
  watch: {
    $route (to, from) {
      if (to.path !== '/register') {
        if (this.$store.state.BaseStats.UserInfo.User_ID > 0) {
          this.QueryUserInfo()
        } else {
          this.checkLogin()
        }
      }

      // 登录成功释放一些定时资源
      if (from.path === '/login') {
        Bus.$emit('CloseInterval')
      }

      // 若是 手机微信
      if (this.$store.state.BaseStats.ScreenClientWidth <= _SM_540) {
        // ========================   from.path    ========================
        if (from.path === '/' || from.path === '/dashboard') {
          Bus.$emit(_NOTIFY_MAIN_TABBAR_SHOW, false)
        }

        if (from.path === '/recharge') {
          Bus.$emit(_NOTIFY_RECHARGE_BOTTOM_TABBAR_SHOW, false)
        }

        if (from.path === '/shopping') {
          Bus.$emit(_NOTIFY_SHOPPING_BOTTOM_TABBAR_SHOW, false)
        }

        if (from.path === '/GoodsDetail') {
          Bus.$emit(_NOTIFY_GOODSDETAILS_BOTTOM_TABBAR_SHOW, false)
        }

        if (from.path === '/my') {
          Bus.$emit(_NOTIFY_MY_BOTTOM_TABBAR_SHOW, false)
        }

        // ========================   to.path    ===========================

        if (to.path === '/dashboard' || to.path === '/') {
          Bus.$emit(_NOTIFY_MAIN_TABBAR_SHOW, true)
        }

        if (to.path === '/recharge') {
          Bus.$emit(_NOTIFY_RECHARGE_BOTTOM_TABBAR_SHOW, true)
        }

        if (to.path === '/shopping') {
          Bus.$emit(_NOTIFY_SHOPPING_BOTTOM_TABBAR_SHOW, true)
        }

        if (to.path === '/GoodsDetail') {
          Bus.$emit(_NOTIFY_GOODSDETAILS_BOTTOM_TABBAR_SHOW, true)
        }

        if (to.path === '/my') {
          Bus.$emit(_NOTIFY_MAIN_TABBAR_SHOW, true)
        }
      }
    }
  },
  created () {
    if (this.IsPrcPco()) {
      document.title = '高原茶油线上商城'
    } else {
      document.title = '云鼎农业线上商城'
    }

    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })

    window.addEventListener('resize', () => {
      this.SetScreenClientWidth(document.documentElement.clientWidth)
    })
  },
  destroyed () {
    this.$root.$off('bv::modal::shown')

    // app退出时删除Cookie
    this.delCookie()
    this.$store.state.BaseStats.UserInfo.LoginStatu = 1
    this.$store.state.BaseStats.UserInfo.User_ID = 0
    this.$store.state.BaseStats.UserInfo.wxOpenID = ''
    this.$store.state.BaseStats.UserInfo.wxUnionID = ''
    this.$store.state.BaseStats.UserInfo.ImgName = ''
    sessionStorage.setItem('store', JSON.stringify(this.$store.state))

    // 在页面销毁时将sessionStorage里数据删除和监听事件
    window.removeEventListener('beforeunload', () => {
      sessionStorage.removeItem('store')
    })

    window.removeEventListener('resize', () => {
      this.SetScreenClientWidth(document.documentElement.clientWidth)
    })
  },
  computed: {
    ...mapGetters('cart', {
      GetTotalQuantity: 'CartTotalQuantity'
    }),
    ...mapState({
      // 0 : 登录成功 1：登录失败（未登录）  2： 其他
      VUXUserInfo: state => state.BaseStats.UserInfo,
      VUXNeedUpdateUserInfo: state => state.BaseStats.NeedUpdateUserInfo
    })
  },
  methods: {
    ...mapMutations('BaseStats', {
      SetScreenClientWidth: 'SetScreenClientWidth',
      SetUserInfo: 'SetUserInfo',
      SetNeedUpdateUserInfo: 'SetNeedUpdateUserInfo'
    }),
    IsPrcPco: function () {
      if (_versionAPP === _prcpcoAPP) {
        return true
      } else {
        return false
      }
    },
    checkLogin () {
      if (isWeiXin()) {
        if ((this.UserInfo.LoginStatu !== 0) && (this.$route.query.User_ID > 0)) {
          // 若是早微信内打开 ， 得到微信授权后登录
          // 登录状态1天后过期(有效期)
          let expireDays = 1000 * 60 * 60 * 24 * 1
          this.setCookie('session', 'blablablablabla...', expireDays)

          this.UserInfo.LoginStatu = 0 // 0 表示已经登录
          this.UserInfo.User_ID = this.$route.query.User_ID
          this.UserInfo.UserName = this.$route.query.UserName
          this.UserInfo.MoblieNo = this.$route.query.MoblieNo
          this.UserInfo.Surplus = this.$route.query.Surplus
          this.UserInfo.Points = this.$route.query.Points
          this.UserInfo.UserGrade_ID = this.$route.query.UserGrade_ID
          this.UserInfo.wxOpenID = this.$route.query.wxOpenID
          this.UserInfo.wxUnionID = this.$route.query.wxUnionID
          this.UserInfo.RegTime = this.$route.query.RegTime
          this.UserInfo.LastLoginTime = this.$route.query.LastLoginTime
          this.UserInfo.Country = this.$route.query.Country
          this.UserInfo.City = this.$route.query.City
          this.UserInfo.NickName = this.$route.query.NickName
          this.UserInfo.ImgName = this.$route.query.ImgName
          this.UserInfo.IsAgent = this.$route.query.IsAgent

          // 更新用户信息
          this.SetUserInfo(this.UserInfo)
          sessionStorage.setItem('store', JSON.stringify(this.$store.state))
        } else {
          this.$router.push('/login')
        }
      } else {
        let StoreObj = JSON.parse(sessionStorage.getItem('store'))
        if (
          !this.getCookie('session') ||
          !StoreObj ||
          StoreObj.BaseStats.UserInfo.LoginStatu !== 0
        ) {
          this.$router.push('/login')
        }
      }
    },
    QueryUserInfo () {
      var that = this
      GetUserInfo(that.$axios, that.VUXUserInfo.User_ID).then(response => {
        if ((typeof response.data !== 'undefined') && (response.data !== null)) {
          this.UserInfo.LoginStatu = that.VUXUserInfo.LoginStatu
          this.UserInfo.User_ID = that.VUXUserInfo.User_ID
          this.UserInfo.UserName = that.VUXUserInfo.UserName
          this.UserInfo.wxOpenID = that.VUXUserInfo.wxOpenID
          this.UserInfo.wxUnionID = that.VUXUserInfo.wxUnionID
          this.UserInfo.RegTime = that.VUXUserInfo.RegTime
          this.UserInfo.LastLoginTime = that.VUXUserInfo.LastLoginTime

          this.UserInfo.MoblieNo = response.data['MoblieNo']
          this.UserInfo.Surplus = response.data['Surplus']
          this.UserInfo.Points = response.data['Points']
          this.UserInfo.UserGrade_ID = response.data['UserGrade_ID']
          this.UserInfo.Country = response.data['Country']
          this.UserInfo.City = response.data['City']
          this.UserInfo.NickName = response.data['NickName']
          this.UserInfo.ImgName = response.data['ImgName']
          this.UserInfo.IsAgent = response.data['IsAgent']

          // 更新用户信息
          this.SetUserInfo(this.UserInfo)
          sessionStorage.setItem('store', JSON.stringify(this.$store.state))
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js